import React from 'react';
import { ComposedModal, InlineLoading, ModalBody, ModalHeader,StructuredListWrapper,StructuredListHead,StructuredListRow, StructuredListCell, StructuredListBody} from "carbon-components-react";
import { useState } from 'react';
import { HubConnectionBuilder } from "@microsoft/signalr"
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { LogType } from '../../components/enums/log-type';

const EventLog = ({show, setShow, enrollmentId}) => {
    const [log, setLog] = useState([]);
    const [processing, setProcessing] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if(!show){
            setLog([]);
            return;
        }
        const connection = new HubConnectionBuilder()
        .withUrl(`${window.env.baseUrl}/enrollmentsHub`)
        .build();
      

      // connect to method that hub invokes
      connection.on("receiveProgress", (message, type) => {

        if(type === LogType.Completed){
          setLog(s => s.concat([message, "No more entries. Please close log to continue."]));

          connection.stop().then(() => {
            setProcessing(false);
            console.log("connection has been closed");
          })
        } else {
            setLog(s => s.concat([message]));

        }
        console.log(message);
      });

      // start connection
      connection.start().then((e) => {
          connection.invoke("JoinGroup", enrollmentId);
          setProcessing(true);
          console.log("Connection to enrollments hub has started")
      });

      return () => {
        connection.stop().then(() => {
            console.log("connection has been closed");
          })
      }
    },
    [show]);

    const close = () => {
        setShow(false);
    }
  
    return ( 
        <>
        <ComposedModal open={show} size="lg" onClose={close} containerClassName="!h-screen">
            <ModalHeader className='text-xl pl-1'>
            {processing === true ?
                <InlineLoading
                    status="active"
                    iconDescription="Processing"
                    description="Submission Log"
                  /> :
                <>Submission Log</>
            }               
            </ModalHeader>
            <ModalBody aria-label="Event Log" className='pr-4'>
                <StructuredListWrapper selection>
                    <StructuredListHead>
                        <StructuredListRow head>
                        <StructuredListCell head>Event 
                </StructuredListCell>
                        </StructuredListRow>
                    </StructuredListHead>
                    <StructuredListBody>
                    {
                    log.map((entry, idx) => 
                    <StructuredListRow key={idx}>
                    <StructuredListCell>{entry}</StructuredListCell>
                </StructuredListRow>                
            )
                }
                    </StructuredListBody>
                </StructuredListWrapper>
                <ul>
                
                </ul>
            </ModalBody>
        </ComposedModal>
        </>
     );
}
 
export default EventLog;